module.exports = __webpack_public_path__ + "img/4.28806b81.jpg";